import './key_codes-a5a2b85e.js';

var ENDPOINTS = {
  BASE_URL: '/mogambo_api',
  POLICY_ENDPOINT: '/generate_s3_policy/',
  SYNTHESIS_ENDPOINT: '/integration/voice/synthesize'
};

var IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif"];
var VIDEO_EXTENSIONS = ["mp4", "avi", "mpeg", "mov", "wmv"];
var AUDIO_EXTENSIONS = ["mpeg", "ogg"];

export { AUDIO_EXTENSIONS as A, ENDPOINTS as E, IMAGE_EXTENSIONS as I, VIDEO_EXTENSIONS as V };
